import { render, staticRenderFns } from "./DatasetIndex.vue?vue&type=template&id=7acc5c54&"
import script from "./DatasetIndex.vue?vue&type=script&lang=js&"
export * from "./DatasetIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports